export enum SettingsNavTabsParams {
   EXTENDED_DOSAGE_TEMPLATES = 'szablony-dawkowania-rozszerzonego',
   VISIT_TEMPLATES = 'szablony-wizyt',
   MAGISTRAL_DRUG_TEMPALTES = 'szablony-lekow-recepturowych',
   PRESCRIPTION_VISIT_TEMPLATES = 'szablony-wizyt-receptowych',
}
